import { render, staticRenderFns } from "./rescrutinerForm.vue?vue&type=template&id=3873fde8&scoped=true&"
import script from "./rescrutinerForm.vue?vue&type=script&lang=js&"
export * from "./rescrutinerForm.vue?vue&type=script&lang=js&"
import style0 from "./rescrutinerForm.vue?vue&type=style&index=0&id=3873fde8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3873fde8",
  null
  
)

export default component.exports